export default "__VITE_ASSET__BctE5AfN__"